module.exports = __webpack_public_path__ + "img/carbonyl.36a0131f.png";